import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import SectorOfInterest from 'src/entities/SectorOfInterest';

export interface ApiSectorOfInterestResponse {
  id: number;
  name: string;
}

interface ApiSectorOfInterestCreateRequest {
}

export class SectorOfInterestFactory extends BaseFactory<SectorOfInterest> {
  public toEntity(args: ApiSectorOfInterestResponse): SectorOfInterest {
    return new SectorOfInterest({
      id: args.id,
      name: args.name,
    });
  }

  public toRequest(project: SectorOfInterest): ApiSectorOfInterestCreateRequest {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/SectorOfInterestFactory.tsx